export default {
  path: '/manufactors/:id',
  component: () =>
    import(
      '@/components/pages/Manufactors/Manufactor.vue'
    )
}
